import React, { useEffect, useState, useRef } from 'react'
import Service from '../../services/news';
import { TextField, TextArea, Button, Paper, CheckBox, IconButton } from '../ui/core';
import { Delete } from '../ui/coreIcons';
import Veditor from '../veditor/veditor';
import ServiceFile from '../../services/file';
export default function Item({ item, onChange, onSave, canDelete }) {
    const [contentRef] = useState(React.createRef());
    const ref = useRef()
    const handleChange = (ev) => {
        let tmpItem = Object.assign({}, item);
        tmpItem[ev.target.id] = ev.target.value || ev.target.checked;

        onChange(tmpItem);
    }

    const handleSave = (ev) => {
        let tmpItem = {};
        tmpItem[ev.target.id] = ev.target.value;
        tmpItem._id = item._id;
        onSave(tmpItem);
    }


    const handleChangeAndSave = (attribute, value) => {
        let tmpItem = Object.assign({}, item);
        tmpItem[attribute] = value;
        onChange(tmpItem);

        let tmpItemSave = {};
        tmpItemSave._id = item._id;
        tmpItemSave[attribute] = value;
        onSave(tmpItemSave);
    }

    const handleFile = () => {
        if (ref && ref.current && ref.current.files && ref.current.files.length > 0) {

            ServiceFile.fileToBase64(ref.current.files[0], 1000)
                .then(result => {
                    handleChangeAndSave('image', result);
                })
        }
    }

    const handleClickSave = () => {

        handleChangeAndSave('content', contentRef.current.innerHTML);

    }


    const handleDelete = () => {
        if (window.confirm("Weet u zeker dat u dit nieuwsitem wilt verwijderen?")) {
            Service.remove(item)
                .then((result => {
                    let tmpItem = Object.assign({}, item);
                    tmpItem.active = false;
                    onChange(tmpItem);
                    onSave(tmpItem);
                }))
                .catch(ex => {
                    console.log(ex)
                })

        }
    }

    if (item && item.active === false) {
        return < div className="padding"><Paper className="padding">Dit nieuwsitem is verwijderd</Paper></div>
    }

    return (
        <div >

            {item && < div className="padding">

                <Paper className="padding">

                    <CheckBox id="publish" label="Publiceren" checked={item.publish} onChange={(ev) => { handleChangeAndSave('publish', ev.target.checked) }} style={{ float: 'right' }} ></CheckBox>
                    <Button onClick={handleClickSave} style={{ backgroundColor: '#ff6A13' }}>Opslaan</Button>  <Button onClick={() => { ref.current && ref.current.click() }} >Upload afbeelding</Button>


                    <TextField id="title" label="Titel" value={item.title} onChange={handleChange} onBlur={handleSave}></TextField>
                    <br /><br />
                    <div className='label'>Afbeelding</div>
                    <img src={item.image} style={{ width: '100px' }} />

                    <input ref={ref} onChange={handleFile} id="uploadFile" type="file" style={{ display: 'none' }} />
                    <br /><br />
                    <div className='label'>Inhoud</div>
                    <Veditor id="html-edit" value={item.content} contentRef={contentRef} files={[]} pages={[]} />
                    {canDelete && <Button style={{ float: 'right', backgroundColor: '#dd4e4e' }} onClick={() => { handleDelete() }}> verwijder item</Button>}

                    <br style={{ clear: 'both' }} />

                </Paper>
            </div>}
        </div>
    )
}
